import { BoardPositions, SquareName } from './types';

// BoardPositions → первое поле FEN: ряды от 8-го к 1-му, пустые клетки — числом.
// Без chess.js: его load()/put() молча отбрасывают второго короля, а редактору
// расстановки нужна любая позиция
export function serializeFenBoard(positions: BoardPositions): string {
  const rows: string[] = [];

  for (let rank = 8; rank >= 1; rank--) {
    let row = '';
    let empty = 0;

    for (const file of 'abcdefgh') {
      const piece = positions[`${file}${rank}` as SquareName];

      if (!piece) {
        empty++;
        continue;
      }
      if (empty) {
        row += empty;
        empty = 0;
      }
      row += piece[0] === 'w' ? piece[1] : piece[1]!.toLowerCase();
    }

    if (empty) row += empty;
    rows.push(row);
  }

  return rows.join('/');
}
